module.exports = __webpack_public_path__ + "media/images/banner_lov_it_en-07ed273b5949c1895d50fe5acb2dafaf.png";